import { MultiPoint } from 'geojson';
import { Layer, Source } from 'react-map-gl';

export const SAMPLES_LAYER_ID = 'samples-layer';

export type SamplesFeatureCollection = GeoJSON.FeatureCollection<
  MultiPoint,
  Record<string, any>
>;

/* eslint-disable-next-line */
export interface SamplesLayerProps {
  data: SamplesFeatureCollection;
  id?: string;
}

export function SamplesLayers(props: SamplesLayerProps) {
  return (
    <Source data={props.data} id="samples-data" type="geojson">
      <Layer
        id={props.id || SAMPLES_LAYER_ID}
        paint={{
          'circle-color': ['get', 'color'],
          'circle-radius': 6,
          'circle-opacity': 0.8,
        }}
        type="circle"
      />
    </Source>
  );
}

export default SamplesLayers;
